import { colors, Icon, iconSizes, mixin, sizes } from "@hubrise/react-components"
import styled, { css } from "styled-components"

import { clickableRoundIcon } from "shared/styles/common"

export const EditButton = styled.div`
  visibility: hidden;
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;

  ${clickableRoundIcon};
  background-color: ${mixin.rgba(colors.backgroundWhite, 0.7)};

  :hover {
    background-color: ${colors.backgroundLight};
  }
`

export const StyledProductOrDeal = styled.div<{ hasImage: boolean; isSelected: boolean }>`
  position: relative;
  background-color: ${colors.backgroundWhite};
  border: 1px solid ${colors.borderLight};
  border-radius: ${sizes.borderRadius};
  ${({ isSelected }) =>
    isSelected &&
    css`
      outline: 3px solid #aaa; // TODO: change the color, or add it to the theme
    `};
  display: grid;
  grid-template-columns: ${(props) => (props.hasImage ? "1fr 8rem" : "1fr")};
  min-height: 8rem;
  cursor: pointer;

  &:hover {
    ${EditButton} {
      visibility: visible;
    }
  }
`

export const Info = styled.div`
  padding: 0.75rem 1rem;
  display: flex;
  flex-direction: column;
`

export const NameAndTags = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
`

export const Name = styled.div`
  font-family: "IBM Plex Sans", Arial, Helvetica, sans-serif;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const Description = styled.div`
  line-height: 1.3;
  margin-bottom: 0.5rem;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

export const PriceAndSize = styled.div`
  display: flex;
  align-items: baseline;
`

export const Price = styled.div``

export const Size = styled.div`
  font-weight: 500;
  ${mixin.noWrapEllipsis};

  :before {
    content: "-";
    padding: 0 0.5em;
    font-weight: normal;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  max-height: 10rem;
  object-fit: cover;
  border-top-right-radius: ${sizes.borderRadius};
  border-bottom-right-radius: ${sizes.borderRadius};
  overflow: hidden;
`

export const EditIcon = styled(Icon).attrs({ code: "edit", size: iconSizes._20 })``
